package gr.tech.meetinggenie.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.models.meeting.DealStatus
import gr.tech.meetinggenie.models.meeting.LossDTO
import gr.tech.meetinggenie.models.meeting.LossReason
import gr.tech.meetinggenie.styles.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun LossesTableInput(
    losses: List<LossDTO>,
    onUpdate: (List<LossDTO>) -> Unit,
) {
    DraggableDataTable(
        rowCount      = losses.size,
        onMove        = { from, to -> onUpdate(losses.toMutableList().also { it.add(to, it.removeAt(from)) }) },
        onDelete      = { index   -> onUpdate(losses.toMutableList().also { it.removeAt(index) }) },
        addButtonText = "Add Loss",
        onAdd         = { onUpdate(losses + LossDTO()) },
        headers = {
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Account / Project Name") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Deal Status") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(200.px).toAttrs()) { Text("Primary Reason") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(220.px).toAttrs()) { Text("Lesson or Signal") }
        },
        rowCells = { index ->
            val loss = losses[index]

            // Account / Project Name
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = loss.accountName,
                    onInput = { v -> onUpdate(losses.toMutableList().also { it[index] = it[index].copy(accountName = v) }) }
                )
            }

            // Deal Status — radio
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(4.px).toAttrs()) {
                Column(verticalArrangement = Arrangement.spacedBy(4.px)) {
                    DealStatus.entries.forEach { option ->
                        Label(attrs = RadioOptionLabelStyle.toModifier().toAttrs()) {
                            Input(
                                type = InputType.Radio,
                                attrs = RadioInputStyle.toModifier().toAttrs {
                                    id("loss-status-$index-${option.name}")
                                    attr("name", "loss-status-$index")
                                    checked(loss.dealStatus == option)
                                    onClick {
                                        onUpdate(losses.toMutableList().also { it[index] = it[index].copy(dealStatus = option) })
                                    }
                                }
                            )
                            Text(option.label)
                        }
                    }
                }
            }

            // Primary Reason — radio
            Td(DataEntryCellStyle.toModifier().minWidth(200.px).padding(4.px).toAttrs()) {
                Column(verticalArrangement = Arrangement.spacedBy(4.px)) {
                    LossReason.entries.forEach { option ->
                        Label(attrs = RadioOptionLabelStyle.toModifier().toAttrs()) {
                            Input(
                                type = InputType.Radio,
                                attrs = RadioInputStyle.toModifier().toAttrs {
                                    id("loss-reason-$index-${option.name}")
                                    attr("name", "loss-reason-$index")
                                    checked(loss.primaryReason == option)
                                    onClick {
                                        onUpdate(losses.toMutableList().also { it[index] = it[index].copy(primaryReason = option) })
                                    }
                                }
                            )
                            Text(option.label)
                        }
                    }
                }
            }

            // Lesson or Signal
            Td(DataEntryCellStyle.toModifier().minWidth(220.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = loss.lessonOrSignal,
                    onInput = { v -> onUpdate(losses.toMutableList().also { it[index] = it[index].copy(lessonOrSignal = v) }) }
                )
            }
        }
    )
}
